import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Clock } from 'lucide-react';

const StickyContactBar = () => {
  return (
    <motion.div 
      className="fixed top-0 left-0 right-0 h-10 flex items-center bg-gradient-to-r from-[#0A2559] to-slate-800 text-white z-50 shadow-md"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      <div className="w-full flex flex-wrap items-center justify-between text-xs gap-2 px-12">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Clock size={14} className="text-orange-400" />
            <span className="font-semibold">Mon-Sat: 9AM-6PM</span>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <a 
            href="tel:+919966005098" 
            className="flex items-center gap-2 hover:opacity-80 transition font-bold bg-orange-500/20 px-2.5 py-1 rounded-lg border border-orange-500/30"
          >
            <Phone size={14} className="text-orange-400" />
            <span>+91 9966005098</span>
          </a>
          <a 
            href="mailto:avc@govalor.co" 
            className="hidden md:flex items-center gap-2 hover:opacity-80 transition font-semibold"
          >
            <Mail size={14} className="text-orange-400" />
            <span>avc@govalor.co</span>
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default StickyContactBar;
